// extracted by mini-css-extract-plugin
export var actionText = "_sa-4";
export var container = "_sa-0";
export var leftSection = "_sa-1";
export var rightSection = "_sa-2";
export var settingsButton = "_sa-6";
export var settingsIcon = "_sa-7";
export var shortcut = "_sa-5";
export var shortcutGroup = "_sa-3";